/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown>, type: NonNullable<unknown> }} Seat_Price_Scheduled_MemberInputs */



/**
* | output |
* | --- |
* | "On {date}, at your renewal, they move to a {type} seat. Until then nothing changes for them." |
*
* @param {Seat_Price_Scheduled_MemberInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const seat_price_scheduled_member = /** @type {((inputs: Seat_Price_Scheduled_MemberInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seat_Price_Scheduled_MemberInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Am ${i?.date}, zu Ihrer Verlängerung, wechselt das Mitglied auf einen ${i?.type}-Platz. Bis dahin ändert sich nichts.`)
	return /** @type {LocalizedString} */ (`On ${i?.date}, at your renewal, they move to a ${i?.type} seat. Until then nothing changes for them.`)
});